import React, { Component } from 'react';

class VerySatisfied extends Component{
    constructor(props){
        super(props);
    }
    render(){
        let color = this.props.color && this.props.color!==''?this.props.color:"#1E4691";
        return(
            <React.Fragment>
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className='hovered' d="M9.45509 14.5106C10.4586 14.5106 11.2722 13.392 11.2722 12.0121C11.2722 10.6323 10.4586 9.51367 9.45509 9.51367C8.45156 9.51367 7.63803 10.6323 7.63803 12.0121C7.63803 13.392 8.45156 14.5106 9.45509 14.5106Z" fill="white" stroke="white"/>
                    <path className='hovered' d="M18.9947 14.5106C19.9982 14.5106 20.8118 13.392 20.8118 12.0121C20.8118 10.6323 19.9982 9.51367 18.9947 9.51367C17.9912 9.51367 17.1776 10.6323 17.1776 12.0121C17.1776 13.392 17.9912 14.5106 18.9947 14.5106Z" fill="white" stroke="white"/>
                    <path d="M16.9505 7.46924L21.4931 8.37777" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                    <path d="M6.72937 8.18084L11.2659 7.24219" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                    <path fill="none" d="M14.2247 26.7756C21.124 26.7756 26.717 21.1826 26.717 14.2833C26.717 7.38401 21.124 1.79102 14.2247 1.79102C7.32542 1.79102 1.73242 7.38401 1.73242 14.2833C1.73242 21.1826 7.32542 26.7756 14.2247 26.7756Z" stroke="white" strokeWidth="2"/>
                    <path fill="none" d="M7.63803 17.6904C7.63803 20.1993 10.5871 22.2331 14.2249 22.2331C17.8627 22.2331 20.8117 20.1993 20.8117 17.6904" stroke="white" strokeWidth="2"/>
                </svg>
                {this.props.text && this.props.text==='true'?(
                    <span>Very Satisfied</span>
                ):(null)}
            </React.Fragment>
        )
    }
}
VerySatisfied.propTypes = {
    color: React.propTypes.node,
    text: React.propTypes.node,
}
export default VerySatisfied;